<template>
  <div>
    <PayOrderDetails
      :isOpen.sync="payOrderDetailsPanel"
      :uploadXML="true"
      v-bind:selectedPayOrder="selectedPayOrder"
      @updatePayOrders="loadPayOrders()"
      @close="resetPayOrderDetails()" />

    <v-flex xs12>
      <v-data-table
        show-select
        v-model="payOrdersTable.selected"
        :loading-text="payOrdersTable.title"
        :loading="payOrdersTable.loading"
        :headers="payOrdersTable.headers"
        :items="payOrdersTable.data"
        :options="payOrdersTable.options"
        item-key="_id"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        :sort-by="['createdAt', 'supplier']"
        :sort-desc="[true, false]"
        class="elevation-1">
        <template v-slot:top>
          <div class="px-3">
            <v-row>
              <v-col cols="12" md="3">
                <div class="d-flex align-center">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="range"
                        label="Rango de fechas"
                        prepend-icon="mdi-calendar"
                        readonly
                        outlined
                        rounded
                        hide-details
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates"
                      :range="true"
                      first-day-of-week="1"
                      :allowed-dates="allowedDates"
                      no-title
                    >
                      <div>
                        <div class="d-flex">
                          <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                          <v-spacer/>
                          <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                          <v-btn :disabled="dates.length < 2" color="primary" @click="loadPayOrders()">OK</v-btn>
                        </div>
                      </div>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="statusSelected"
                  :items="statuses"
                  item-text="text"
                  item-value="value"
                  label="Status"
                  hide-details
                  outlined
                  rounded
                  dense
                  @change="loadPayOrders()"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Busca proveedor"
                  dense
                  outlined
                  rounded
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div class="flex-md-row-reverse flex-sm-column justify-space-between d-sm-flex my-2">
                  <div class="d-flex align-center">
                    <Button class="mr-1" size="x-small" @click="openUploadXMLDialog()" v-show="payOrdersTable.selected.length > 1">
                      <v-icon size="20px" class="mr-1">$relate</v-icon>
                      Adjuntar factura
                    </Button>
                    <v-btn
                      class="mr-4 white--text"
                      rounded
                      color="blue"
                      depressed
                      @click="openRelateInvoiceSatws()"
                      v-show="payOrdersTable.selected.length > 1">
                      <v-icon>mdi-magnify</v-icon>
                      Buscar facturas
                    </v-btn>

                    <Button class="mr-1 colorButton" size="x-small" @click="openAttachDialog()" v-show="payOrdersTable.selected.length > 1">
                      Adjuntar documento
                    </Button>

                    <div class="ml-3">
                      Total: {{ totalAmountSelected | toFixNumber(2) | numberWithComma | prefix('$') }}
                    </div>
                    <div class="ml-3">
                      Transacciones seleccionadas: {{ payOrdersTable.selected.length }}
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:[`item._id`]="{ item }">
          <div>
            <a @click="openPayOrderDetailsPanel(item)"  class="link">{{ item._id }}</a>
          </div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div class="text-right">
            {{ item.total | toFix2 | numberWithComma | prefix('$') }}
          </div>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          <div>
            {{ $moment(item.createdAt).format('DD/MM/YYYY') }}
          </div>
        </template>
        <template v-slot:[`item.paymentMethod`]="{ item }">
          <div>
            {{ PAYORDER_PAYMENT_TYPES[item.paymentMethod] }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div>
            {{ PAYORDER_STATUS_TYPES[item.status] }}
          </div>
        </template>
        <template v-slot:[`item.providerName`]="{ item }">
          <div>
            {{ item.providerName ?  item.providerName : '-' }}
          </div>
        </template>
        <template v-slot:[`item.support`]="{ item }">
          <div class="d-flex justify-end align-center">
            <v-tooltip left v-if="movementsPermissions['delete-pay-order']">
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  class="mr-3"
                  color="error"
                  v-on="on"
                  @click="openRemoveDialog(item)"
                  >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Borrar orden de pago</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas borrar la orden de pago?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" text @click="onCloseRemoveDialog">No</v-btn>
          <v-btn color="black darken-1" text @click="remove">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <attach-dialog
      :dialog="attachDialog"
      :orders="payOrdersTable.selected"
      @close="attachDialog = false">
    </attach-dialog>

    <UploadXML ref="uploadXMLDialog" :orders="payOrdersTable.selected" @refresh="loadPayOrders"/>
    <RelateInvoiceSatws ref="relateInvoiceSatws" :orders="payOrdersTable.selected" @refresh="loadPayOrders"/>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { isEmpty, debounce } from 'lodash'

import PayOrderDetails from '@/components/sidePanels/PayOrderDetails'
import attachDialog from '@/components/modals/AttachDocument'
import Button from '@/components/elements/Button'
import UploadXML from '@/components/modals/UploadXML'
import RelateInvoiceSatws from '@/components/modals/RelateInvoiceSatws'

export default {
  name: 'PaymentOrders',
  components: {
    PayOrderDetails,
    Button,
    UploadXML,
    attachDialog,
    RelateInvoiceSatws
  },
  data () {
    return {
      overlay: false,
      section: this.$i18n.t('expenses.registerMovements.section'),
      payOrdersTable: {
        title: this.$i18n.t('expenses.registerMovements.payOrders.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.id'), value: '_id', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.supplier'), value: 'providerName', sortable: true },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.amount'), value: 'total' },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.date'), value: 'createdAt' },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.paymentType'), value: 'paymentMethod', sortable: false },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.status'), value: 'status' },
          { text: this.$i18n.t('expenses.registerMovements.payOrders.headers.support'), value: 'support' }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 30,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        },
        selected: []
      },
      search: '',
      statusSelected: '',
      datePicker: false,
      dates: [],
      loadingBtn: '',
      disabled: false,
      payOrderDetailsPanel: false,
      selectedPayOrder: null,
      PAYORDER_PAYMENT_TYPES: {
        balance: this.$i18n.t('expenses.registerMovements.movements.paymentTypes.balance'),
        credit: this.$i18n.t('expenses.registerMovements.movements.paymentTypes.credit')
      },
      PAYORDER_STATUS_TYPES: {
        created: this.$i18n.t('expenses.registerMovements.movements.statusTypes.created'),
        pending_payment: this.$i18n.t('expenses.registerMovements.movements.statusTypes.pendingPayment'),
        paid: this.$i18n.t('expenses.registerMovements.movements.statusTypes.paid')
      },
      suppliers: {
        data: [],
        loading: false
      },
      removeDialog: false,
      removePayOrder: {},
      openUploadXml: false,
      xmlFile: null,
      overlayCreateByXML: false,
      attachDialog: false
    }
  },
  async mounted () {
    await this.loadPayOrders()
  },
  computed: {
    movementsPermissions () {
      return this.$store.state.login.permissions['expenses'].components['financial-movements'].actions
    },
    statuses () {
      return [
        { text: 'Por pagar', value: 'pending_payment' },
        { text: 'Pagada', value: 'paid' }
      ]
    },
    range () {
      const dates = this.dates
      return dates.length < 2 ? '' : `${dates[0]} / ${dates[1]}`
    },
    totalAmountSelected () {
      return this.payOrdersTable.selected.reduce((acc, curr) => acc + curr.amount, 0)
    }
  },
  watch: {
    'search': debounce(async function (val) {
      if (val.length >= 2) {
        const params = {
          restaurant: this.$store.state.currentRestaurant.data._id,
          providerName: `/${val}/i`,
          isSupportOrder: true,
          skip: 0
        }
        if (this.statusSelected) params.status = this.statusSelected
        if (this.dates.length === 2) {
          const dates = [this.dates[0], this.dates[1]].sort((a, b) => {
            if (a > b) return 1
            if (a < b) return -1
            return 0
          })
          params.startDate = (dates[0])
          params.endDate = dates[1]
        }
        this.payOrdersTable.loading = true
        try {
          const response = await this.$api.get(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}`, params)
          this.payOrdersTable.data = response
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.payOrdersTable.loading = false
      } else {
        this.loadPayOrders()
      }
    }, 300),
    '$store.state.currentRestaurant.data': async function (val) {
      this.resetForm()
      await this.loadPayOrders()
    }
  },
  methods: {
    openAttachDialog () {
      this.attachDialog = true
    },
    async closeAttachDialog () {
      this.attachDialog = false
      this.loadPayOrders()
    },
    allowedDates (val) {
      return this.$moment(val).isSameOrBefore(new Date())
    },
    resetForm () {
      this.payOrdersTable.data = []
      this.payOrdersTable.total = 0
      this.payOrdersTable.selected = []
      this.loadingBtn = ''
      this.disabled = false
      this.payOrderDetailsPanel = false
      this.selectedPayOrder = null
    },
    async loadPayOrders (params = null) {
      params = params || {
        restaurant: this.$store.state.currentRestaurant.data._id,
        isSupportOrder: true
      }
      if (this.statusSelected) params.status = this.statusSelected
      if (this.dates.length === 2) {
        const dates = [this.dates[0], this.dates[1]].sort((a, b) => {
          if (a > b) return 1
          if (a < b) return -1
          return 0
        })
        params.startDate = (dates[0])
        params.endDate = dates[1]
        this.datePicker = false
      }
      this.payOrdersTable.loading = true
      try {
        const response = await this.$api.get(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}`, params)
        this.payOrdersTable.selected = []
        this.payOrdersTable.data = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.payOrdersTable.loading = false
    },
    openPayOrderDetailsPanel (item) {
      this.payOrdersTable.selected = []
      this.selectedPayOrder = item
      this.payOrderDetailsPanel = true
    },
    closePayOrderDetailsPanel () {
      this.payOrderDetailsPanel = false
    },
    resetPayOrderDetails () {
      this.selectedPayOrder = {}
    },
    isEmpty,
    async resetDate () {
      this.dates = []
      await this.loadPayOrders()
      this.datePicker = false
    },
    async openRemoveDialog (item) {
      this.removeDialog = true
      this.removePayOrder = item
    },
    onCloseRemoveDialog () {
      this.removeDialog = false
      this.removePayOrder = {}
    },
    remove: async function () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/expenses/${this.$store.state.currentRestaurant.data._id}/${this.removePayOrder._id}`)
        this.$toasted.show('Orden de pago eliminada exitosamente', { duration: 3000 })
        await this.loadPayOrders()
        this.removePayOrder = {}
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.onCloseRemoveDialog()
      this.overlay = false
    },
    openUploadXMLDialog () {
      this.$refs.uploadXMLDialog.open()
    },
    openRelateInvoiceSatws () {
      this.$refs.relateInvoiceSatws.open()
    }
  }
}
</script>

<style lang="scss" scoped>
  .link:hover {
    text-decoration: underline;
    color: #3366BB !important;
  }

  .colorButton {
    background-color: #2196F3 !important;
  }

  .calendarTextField {
    height: 34px;
    width: 240px;
    border-radius: 22px;

    & ::v-deep .v-label {
      top: auto;
    }
  }

  .dateButton {
    text-transform: none;
  }
</style>
